import global from './global';
import components from './components';

document.addEventListener('DOMContentLoaded', (event) => {
    global.init();
    components.init();
});
